import React from "react";
import { useNavigate } from "react-router-dom";
import { LiveDataQualityStatus } from "../../LiveDataQualityCircle";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { formatDate } from "@telerik/kendo-intl";
import moment from "moment";

const AssetGridCard = ({
  asset,
  cardClicked,
  getTimeZoneDateTime,
  t,
  teamConfig,
  darkMode,
}) => {
  const navigate = useNavigate();

  const getPropertyData = (fp) => {
    const data = asset?.properties.find((p) => p.id === fp.fieldId);
    return data;
  };

  const getSensorValues = (fp) => {
    const data = asset.parameters.find((p) => p.id === fp.fieldId);
    return data;
  };

  const getParamValues = (paramId) => {
    const data = asset.parameters.find((p) => p.parameterId === paramId);
    return data;
  };
  return (
    <div
      className={`${
        asset.cardClicked && asset.cardClicked === true
          ? "border-white"
          : asset.latestAlarm?.status === "warning"
          ? "dark:border-orange-700 border-[#958798]"
          : asset.latestAlarm?.status === "critical"
          ? "dark:border-red-700  border-red-500"
          : "dark:border-blue-700 border-blue-500"
      }
         ${
           asset.latestAlarm
             ? asset.latestAlarm?.status === "warning"
               ? `dark:to-zinc-900 dark:from-orange-700 from-[#958798] to-[#BDBAC3]`
               : asset.latestAlarm?.status === "critical" &&
                 "dark:from-red-700 dark:to-zinc-900 from-red-600 to-zinc-300"
             : `hover:border-blue-700 dark:from-blue-700 dark:to-zinc-900 from-zinc-200 to-zinc-300`
         } parent flex-col h-fit w-full rounded-lg bg-gradient-to-b border-2 hover:border-white`}
      key={asset.id}
      onClick={() => cardClicked(asset)}
    >
      <div className="flex justify-between md:px-4 px-2 md:py-5 py-2">
        <div className="flex md:gap-2 gap-1 items-center">
          <label
            className={`font-semibold md:text-base sm:text-sm text-xs dark:text-white text-black`}
          >
            {asset.name}
          </label>
          {asset?.timeStamp &&
            asset?.devices.map((x, index) => {
              return (
                <LiveDataQualityStatus
                  timeStamp={asset?.timeStamp}
                  enabled={true}
                  interval={x?.device.interval}
                  parameterName={x?.device.name}
                  renderType={"monitor"}
                  key={index}
                  playBackMode={100}
                />
              );
            })}
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={(e, id) => {
              navigate(`/details/asset/${asset.id}`);
            }}
            className={`${
              (asset.cardClicked && asset.cardClicked === true) ||
              asset.latestAlarm !== ""
                ? "dark:text-white text-black dark:border-white border-black"
                : " dark:text-white text-black dark:border-white border-black"
            } child border rounded-4xl md:w-16 sm:w-12 w-10 font-medium md:text-xxs sm:text-xxs text-xxxs flex justify-center items-center`}
          >
            {t("home.assetList.detailsButtonText")}
          </button>
        </div>
      </div>
      <div className="grid grid-cols-3 md:gap-y-4 sm:gap-y-3 gap-y-2 auto-cols-fr md:px-4 sm:px-3 px-2">
        {teamConfig &&
          teamConfig
            ?.sort((a, b) => a.orderIndex - b.orderIndex)
            .map((fp, index) => {
              const sensorValue = getSensorValues(fp);
              const propertiesValue = getPropertyData(fp);
              return (
                <div className="flex items-center w-full" key={index}>
                  <div
                    className={`${
                      index === 0 || index === 3
                        ? ""
                        : "border-l md:pl-3 sm:pl-2 pl-1"
                    } flex-col w-min border-zinc-700`}
                  >
                    <div
                      className={`dark:text-zinc-400 text-zinc-900 font-semibold md:text-xs sm:text-xxs text-xxs overflow-hidden truncate text-ellipsis md:max-w-[100px] sm:max-w-[60px] max-w-[40px]`}
                    >
                      {asset && fp.fieldType === "parameter" ? (
                        <>
                          {sensorValue?.enabled ? (
                            <TooltipComponent
                              opensOn={
                                sensorValue?.timeStamp ? "Hover" : "Custom"
                              }
                              content={
                                sensorValue?.timeStamp
                                  ? formatDate(
                                      getTimeZoneDateTime(
                                        sensorValue?.timeStamp
                                      ),
                                      "dd MMM yyyy hh:mm:ss a"
                                    )
                                  : ""
                              }
                            >
                              <div className="md:text-xs sm:text-xxs text-xxxs">
                                <label>
                                  {sensorValue.value &&
                                  sensorValue.type === "Number"
                                    ? parseFloat(
                                        parseFloat(sensorValue.value).toFixed(2)
                                      )
                                    : sensorValue.value}
                                </label>
                                <label>&nbsp;{sensorValue?.unit}</label>
                              </div>
                            </TooltipComponent>
                          ) : (
                            <div className="text-red-500 md:text-xxs text-xxxs ">
                              {t("home.assetList.disabled")}
                            </div>
                          )}
                        </>
                      ) : (
                        <label className="">{propertiesValue?.value}</label>
                      )}
                    </div>
                    <div
                      className={`dark:text-neutral-500 text-neutral-500 font-medium md:text-xxs sm:text-xxxs text-[6px] truncate md:max-w-[90px]`}
                    >
                      {fp.fieldType === "parameter" ? (
                        // <label>{sensorValue?.sensor?.name}</label>
                        <label>{sensorValue?.name}</label>
                      ) : (
                        <label>{propertiesValue?.key}</label>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
      <div
        className={`dark:bg-[#181921] text-zinc-700 dark:border-zinc-800 bg-zinc-200 border-zinc-500  border-t w-full rounded-b-lg md:pl-4 sm:pl-3 pl-2 md:pr-2 pr-1 md:mt-3 mt-1 font-medium md:text-xxs sm:text-xxxs text-[6px] md:pt-2 pt-1 md:pb-2 pb-1`}
      >
        {asset.latestAlarm ? (
          <label className="dark:text-white text-black">
            {/* {asset.latestAlarm?.status?.charAt(0).toUpperCase() +
                asset.latestAlarm.status.slice(1)} */}
            {t(`home.alarmList.status.${asset.latestAlarm.status}`)}
            &nbsp;
            {getParamValues(asset.latestAlarm.parameterId)?.name}
            &nbsp; on &nbsp;
            {/* {formatDate(new Date(latestAlarm.timeStamp), "dd-MM-yyyy hh:mm:ss a")} */}
            {moment(getTimeZoneDateTime(asset.latestAlarm.timeStamp)).format(
              "DD-MMM-YYYY hh:mm a"
            )}
          </label>
        ) : (
          <label className="dark:text-white text-black">
            {t("home.assetList.cardNoAlarmText")}
          </label>
        )}
      </div>
    </div>
  );
};

export default AssetGridCard;
